import React, { useContext } from 'react';
import { Breadcrumbs, MetadataContext, ResponsiveImage } from '@/components';

import { ReportHeroModel } from './ReportHero';
import classNames from 'classnames';

import HeroData from './HeroData';

export type HalfBannerType = ReportHeroModel & React.HTMLAttributes<HTMLDivElement>;

const HalfBanner = (data: HalfBannerType) => {
  const { heroImageAlignment, heroImage, title, breadcrumbs } = data.props;
  const { isPublic } = useContext(MetadataContext);

  return (
    <div
      className={classNames(
        'flex w-full flex-col print:flex-col',
        heroImageAlignment === 'Left' ? 'sm:flex-row' : 'sm:flex-row-reverse',
      )}
    >
      <div
        className={classNames('relative sm:w-1/2 print:w-full', isPublic ? 'sm:aspect-[375/211]' : 'aspect-[375/211]')}
      >
        {heroImage && (
          <div className="top-0 left-0 h-full w-full sm:absolute">
            <ResponsiveImage
              image={heroImage.desktopImage}
              widths={{ xs: 1, sm: 456, md: 512, lg: 766, xl: 611, xxl: 1000 }}
              heights={{ xs: null, sm: 684, md: 769, lg: 1150, xl: 918, xxl: 1502 }}
              dataNotLazy
              preload
              className="hidden sm:block"
            />
            {!isPublic && (
              <ResponsiveImage
                image={heroImage.mobileImage}
                widths={{ xs: 640, sm: 1 }}
                heights={{ xs: 360, sm: 1 }}
                dataNotLazy
                preload
                className="sm:hidden"
              />
            )}
          </div>
        )}
      </div>
      <div
        className={classNames(
          'color-from-bg flex pt-4 pb-4 sm:w-1/2 lg:pt-12 print:w-full',
          heroImageAlignment === 'Left' ? 'sm:justify-start' : 'sm:justify-end',
        )}
      >
        <div
          className={classNames(
            'max-w-[800px] px-5 print:max-w-full',
            heroImageAlignment === 'Left' ? 'sm:pr-[40px] sm:pl-12 lg:pr-[60px]' : 'sm:pr-12 sm:pl-[40px] lg:pl-[60px]',
          )}
        >
          <Breadcrumbs className="py-3" data={breadcrumbs} />

          <h1 className="mt-2 pt-4 pb-4 text-[35px] leading-10 font-light sm:mt-6 md:mt-9 xl:mt-[70px] xl:pb-8 xl:text-[70px] xl:leading-[74px]">
            {title}
          </h1>

          <HeroData
            layout="vertical"
            className={classNames(
              'my-6 xl:!gap-10',
              '[&_.ai-icon]:h-5 [&_.ai-icon]:w-5 [&_.chip]:py-1 [&_.chip]:text-sm [&_.chip]:leading-5',
              'md:[&_.richText_*]:!text-lg md:[&_.richText_*]:!leading-6 xl:[&_.richText_*]:!text-[26px] xl:[&_.richText_*]:!leading-8',
            )}
            {...data}
          />
        </div>
      </div>
    </div>
  );
};

export default HalfBanner;
